<app-input-label
    [label]="label"
    [labelPosition]="labelPosition"
    [for]="id"
    [isRequired]="isRequired"
    [isEditMode]="isEditMode">
    @if (isEditMode) {
        <kendo-daterange>
            <kendo-dateinput
                kendoDateRangeStartInput
                [ngClass]="generateInputStyle()"
                [disabled]="isDisabled"
                [isRequired]="isRequired"
                [format]="format"
                [ngModel]="dateValue()?.startDate"
                (valueChange)="onValueChange({ startDate: $event, endDate: dateValue()?.endDate })"
                (inputFocus)="onFocusIn()"
                (inputBlur)="onFocusOut()" />
            <kendo-dateinput
                kendoDateRangeEndInput
                [ngClass]="generateInputStyle()"
                [isRequired]="isRequired"
                [disabled]="isDisabled"
                [format]="format"
                [ngModel]="dateValue()?.endDate"
                (valueChange)="onValueChange({ startDate: dateValue()?.startDate, endDate: $event })"
                (inputFocus)="onFocusIn()"
                (inputBlur)="onFocusOut()" />
        </kendo-daterange>
    } @else {
        <div
            class="pb-1 pt-1.5"
            kendoTooltip
            position="top"
            [title]="value()?.startDate | date: format + ' - ' + value()?.endDate | date: format">
            {{ value()?.startDate | date: format }} - {{ value()?.endDate | date: format }}
        </div>
    }
</app-input-label>
